import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

export const LotMobileCardLoader = () => {
  const theme = useTheme()
  return (
    <ContentLoader
      speed={2}
      width={340}
      height={200}
      viewBox="0 0 340 200"
      backgroundColor={theme.colours.grey[45]}
      foregroundColor={theme.colours.grey[30]}
    >
      <rect x="0" y="0" rx="4" ry="4" width="100" height="140" />
      <rect x="120" y="0" rx="4" ry="4" width="220" height="24" />
      <rect x="120" y="30" rx="4" ry="4" width="210" height="18" />
      <rect x="120" y="70" rx="4" ry="4" width="70" height="16" />
      <rect x="120" y="110" rx="4" ry="4" width="160" height="16" />
      <rect x="120" y="130" rx="4" ry="4" width="130" height="16" />
      <rect x="120" y="170" rx="4" ry="4" width="90" height="16" />
    </ContentLoader>
  )
}
